import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiFetch } from "../../../utils";

// Async thunk to add chatbot tenant
export const addChatbotTenant = createAsyncThunk(
    "chatbot/addTenant",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await apiFetch("api/a/callback/chatbot/tenants", {
                method: "POST",
                body: JSON.stringify(payload),
                headers: { "Content-Type": "application/json" },
                idempotencyAction: "chatbot:tenants:create"
            });
            return await response.json();
        } catch (error) {
            return rejectWithValue(error.message || "Failed to give credits");
        }
    }
);

export const updateChatbotTenant = createAsyncThunk(
    "chatbot/updateTenant",
    async ({ tenantId, payload }, { rejectWithValue }) => {
        try {
            const response = await apiFetch(`/api/a/callback/chatbot/tenants/${tenantId}`, {
                method: "PUT",
                body: JSON.stringify(payload),
                headers: { "Content-Type": "application/json" }
            });
            return await response.json();
        } catch (error) {
            return rejectWithValue(error.message || "Failed to update tenant");
        }
    }
);

export const deleteChatbotTenant = createAsyncThunk(
    "chatbot/deleteTenant",
    async (tenantId) => {
        const res = await apiFetch(`api/a/callback/chatbot/tenants/${tenantId}`, {
            method: "DELETE",
        });

        return await res.json();
    }
)

// Async thunk to fetch all users (once)
export const fetchChatbotTenants = createAsyncThunk(
    "chatbot/fetchChatbotTenants",
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiFetch("api/a/callback/chatbot/tenants");
            return await response.json(); // expect array of users
        } catch (error) {
            return rejectWithValue([]);
        }
    }
);

const chatbotSlice = createSlice({
    name: "chatbot",
    initialState: {
        tenants: [],
        loading: true,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // give credits
            .addCase(addChatbotTenant.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addChatbotTenant.fulfilled, (state, action) => {
                state.tenants.push(action.payload); // add new tenant to list
                state.loading = false;
                state.error = null;
            })
            .addCase(addChatbotTenant.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload.error;
            })
            .addCase(updateChatbotTenant.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateChatbotTenant.fulfilled, (state, action) => {
                const updatedTenant = action.payload;

                var index = state.tenants.findIndex(
                    t => t.id === updatedTenant.id
                );

                if (index !== -1) {
                    state.tenants[index] = updatedTenant; // replace
                } else {
                    state.tenants.push(updatedTenant); // fallback (optional)
                }

                state.loading = false;
                state.error = null;
            })
            .addCase(updateChatbotTenant.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload.error;
            })
            // fetch all users
            .addCase(fetchChatbotTenants.pending, (state) => {
                state.loading = true;
                state.error = false;
            })
            .addCase(fetchChatbotTenants.fulfilled, (state, action) => {
                state.tenants = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(fetchChatbotTenants.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload.error;
            })
        }
    }
);

export default chatbotSlice.reducer;
